import { Routes } from '@angular/router';

import { PagePathResolver } from '@digital-platform/rs-cms/services';
import { FallbackPageComponent } from './fallback-page/fallback-page.component';

export const ROUTES: Routes = [
  {
    path: '',
    component: FallbackPageComponent,
    resolve: {
      pagePath: PagePathResolver,
    },
  },
];
